module.exports = {
	"articleTitle1": "A salty story",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Pretzel Bell",
	"articleLink1": "https://www.michigandaily.com/content/salty-story",
	"articleLink2": "https://www.michigandaily.com/section/news/pretzel-bell-returns-campus",
	"articleSnippet1": "Nov 29, 2007 ... For more than 50 years, a bar known simply as \"P-Bell\" topped the list. The \nPretzel Bell, which opened in 1934 after Prohibition was repealed, ...",
	"articleSnippet2": "Mar 21, 2016 ... Jon Carlson and Greg Lobdell, who are heading the revival of the Pretzel Bell, \nexplain their vision for the new restaurant at its location at the ...",
	"foodRecommendations": [],
	"articleTitle2": "Iconic restaurant Pretzel Bell offers walk-through for alumni ",
	"address": "226 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279742,
		"lng": -83.748986
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pretzelbell.json
// module id = 952
// module chunks = 0